export var ConditionWrapper = function (_a) {
    var _b = _a.condition, condition = _b === void 0 ? false : _b, children = _a.children;
    var show = false;
    if (typeof condition === 'function') {
        show = condition();
    }
    else {
        show = condition;
    }
    return show ? children : null;
};
